<div class="container">
    <!-- Left Menu Column -->
    <div class="menu-column" [class.hidden]="!isMenuVisible" id="menuColumn">
        <!-- Header -->
        <div class="menu-header">
            <div class="header-content">
                <img
                    (click)="openBaseUrl()"
                    class="logo ng-star-inserted"
                    src="https://az-cdn.selise.biz/selisecdn/cdn/pcx/images/ipex_logo.svg"
                    style="cursor: pointer;"
                />
                <span class="header-title">Automation Report</span>
                <button class="header-sort-button" [class.active]="isAsending" (click)="sort()" *ngIf="menuItems && menuItems.length > 0" title="Toggle sort order">
                    <i class="pi" [ngClass]="isAsending ? 'pi-sort-amount-down' : 'pi-sort-amount-up'"></i>
                </button>
            </div>
        </div>

        <!-- Menu Items Grouped by Month -->
        <div class="menu-items">
            <mat-progress-bar class="dashboard-progress-bar" *ngIf="isMenuLoading" mode="indeterminate" id="am-1254">
            </mat-progress-bar>

            <ng-container *ngFor="let group of getGroupedItems()">
                <div class="month-header">{{ group.month }}</div>
                <div
                    *ngFor="let item of group.items"
                    class="menu-item"
                    [class.active]="currentContent === item.id"
                    (click)="loadContent(item)"
                >
                    <div class="menu-item-indicator" [class.latest]="isLatestItem(item)"></div>
                    <div class="menu-item-content">
                        <div class="menu-item-title">{{ item.title }}</div>
                        <span class="menu-item-date">{{ item.createdate | pcxDateFormate : true }}</span>
                    </div>
                    <div class="menu-item-status" *ngIf="getItemStatus(item) || isLatestItem(item)">
                        {{ isLatestItem(item) ? 'LATEST' : getItemStatus(item) }}
                    </div>
                    <span class="menu-item-arrow">›</span>
                </div>
            </ng-container>
        </div>
    </div>

    <!-- Right Content Column -->
    <div class="content-column">
        <div class="iframe-container">
            <div class="loading-overlay" *ngIf="isLoading">
                <div class="loading-spinner"></div>
                <div class="loading-text">Loading content...</div>
                <div class="loading-percentage">{{ loadingPercentage }}%</div>
            </div>

            <div class="error-message" *ngIf="error">
                <div class="error-icon">⚠️</div>
                <div class="error-title">Unable to Load Report</div>
                <div class="error-text">{{ error }}</div>
                <div class="error-actions">
                    <button class="control-btn retry-btn" (click)="refreshIframe()" *ngIf="retryCount < maxRetries">
                        Retry ({{ retryCount }}/{{ maxRetries }})
                    </button>
                    <button class="control-btn cancel-btn" (click)="loadDefaultContent()">
                        Back to Home
                    </button>
                </div>
            </div>

            <iframe
                id="contentFrame"
                class="iframe-content"
                [src]="currentUrl"
                (load)="onIframeLoad()"
                (error)="onIframeError()"
            >
                <p>Your browser does not support iframes.</p>
            </iframe>
        </div>
    </div>
</div>
